import { CellContext, createColumnHelper } from "@tanstack/react-table";
import React, { useState, useRef } from "react";
import { ITipo_Campo } from "../../../helpers/IFormHelper";
import { IDesviacion, ISearchDocumentosAnalisisCausal } from "../../../entities/IDesviacion";
import { shortDate } from "../../../helpers/dateHelper";
import { Tab, Tabs } from "react-bootstrap";
import { ICausaInmediata } from "../../../entities/ICausaInmediata";
import { ICausaBasica } from "../../../entities/ICausaBasica";
import { ICausaSistema } from "../../../entities/ICausaSistema";
import ArbolCausalService from "../../../services/ArbolCausa";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import DesviacionService from "../../../services/DesviacionService";
import Loading from "../../../cross/Loading";
import AgregarAnalisisCausalBasica from "./AgregarAnalisisCausalBasica";
import IDocumentoDesviacion, { IEvidenciasArbolCausal } from "../../../entities/IDocumentoDesviacion";
import { ROW_COUNT } from "../../../helpers/variableHelper";
import { E_TipoDocumentoDesviacion } from "../../../enums/E_TIpoDocumentoDesviacion";
import AgregarAnalisisCausalInmediato from "./AgregarAnalisisCausalInmediato";
import AgregarAnalisisCausalSistema from "./AgregarAnalisisCausalSistema";
import { getFileName } from "../../../helpers/pathHelper";
import Swal, { SweetAlertResult } from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { EnumEstadoDesviacion } from "../../../entities/helper/EnumEstadoDesviacion";
import { E_EstadoFormCausaDesviacion } from "../../../enums/E_EstadoFormulario";
import { AdminListaPagination, IPagination } from "../../../controls/AdminListaPagination";
import { ETipoDesviacion } from "../../../enums/E_TipoDesviacion";
import { ETipoCausa } from "../../../enums/E_TipoCausa";
import { E_EstadoCausa } from "../../../enums/E_EstadoCausa";
import RenderTitle from "../../../controls/RenderTitle";
import RenderValue from "../../../controls/RenderValue";
import { E_GravedadPotencial } from "../../../enums/E_GravedadPotencial";
import IAuditoria from "../../../entities/IAuditoria";
const MySwal = withReactContent(Swal);

interface IRegistroAnalisisCausalProps {
  token: string;
  readonly: boolean;
  loading?: boolean;
  items1?: Array<ICausaInmediata>;
  items2?: Array<ICausaBasica>;
  items3?: Array<ICausaSistema>;
  itemsDoc?: Array<ISearchDocumentosAnalisisCausal>;
  open1?: boolean;
  open2?: boolean;
  open3?: boolean;
  is_test?: boolean;
  id_desv?: string;
  flujo_corto?: boolean;
  selectedAudit: IAuditoria | null;
}
export default function RegistroAnalisisCausal({// NOSONAR "Se aplica en esta linea ya que SONAR nos arroja 129 como valor de complejidad cognitiva. Esta función realiza varias validaciones para la carga de las acciones, y para manejar las pruebas unitarias".
  token,
  readonly,
  loading,
  open1,
  open2,
  open3,
  items1,
  items2,
  items3,
  is_test,
  itemsDoc,
  id_desv,
  flujo_corto,
  selectedAudit,
}: IRegistroAnalisisCausalProps) {
  let search = new URLSearchParams(window.location.search);
  const idDesviacion = parseInt(search.get("id") || (id_desv ?? "0"));
  const [selectedDesviacion, setSelectedDesviacion] = useState<IDesviacion | null>(null);
  const [isLoading, setIsLoading] = useState(loading ?? true);
  const [isLoadingDocuments, setIsLoadingDocuments] = useState(loading ?? true);

  const [listadoDocumentosAC, setListadoDocumentosAC] = useState<Array<ISearchDocumentosAnalisisCausal>>(itemsDoc ?? []);
  const [listCausasInmediatas, setListCausasInmediatas] = useState<Array<ICausaInmediata>>(items1 ?? []);
  const [listCausasBasicas, setListCausasBasicas] = useState<Array<ICausaBasica>>(items2 ?? []);
  const [listCausasSistema, setListCausasSistema] = useState<Array<ICausaSistema>>(items3 ?? []);
  const [isOpenAddCI, setIsOpenAddCI] = useState<boolean>(open1 ?? false);
  const [isOpenAddCB, setIsOpenAddCB] = useState<boolean>(open2 ?? false);
  const [isOpenAddCS, setIsOpenAddCS] = useState<boolean>(open3 ?? false);
  const [estadoModalCausa, setEstadoModalCausa] = useState<E_EstadoFormCausaDesviacion>(E_EstadoFormCausaDesviacion.Lectura);
  const [selectdCausaBasica, setSelectedCausaBasica] = useState<ICausaBasica | null>(null);
  const [selectdCausaInmediata, setSelectedCausaInmediata] = useState<ICausaInmediata | null>(null);
  const [selectdCausaSistema, setSelectedCausaSistema] = useState<ICausaSistema | null>(null);
  const refTxtDescripcionDocumento = React.createRef<HTMLTextAreaElement>();
  const [lenTxtDescripcionDocumento, setLenTxtDescripcionDocumento] = useState(0);
  const refInptDocumentoAC = React.createRef<HTMLInputElement>();
  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  const [isSendingData, setIsSendingData] = useState(false);
  const [isUploadingDocs, setIsUploadingDocs] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(readonly ?? true);
  const [isFlujoCorto, setIsFlujoCorto] = useState<boolean | null>(flujo_corto ?? null);
  const totalPagesListCausasI = useRef<number>(0);
  const totalPagesListCausasB = useRef<number>(0);
  const totalPagesListCausasS = useRef<number>(0);
  const totalPagesListDocumentos = useRef<number>(0);

  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentVerCausaSistema = (info: any) => {
    return (
      <i
        className="bi bi-search iconSearch"
        title="Ver Desviación"
        onClick={() => {
          setSelectedCausaSistema(info.row.original);
          setEstadoModalCausa(E_EstadoFormCausaDesviacion.Lectura);
          setIsOpenAddCS(true);
        }}></i>
    );
  };

  const componentEditarCausaSistema = (info: any) => {
    return (
      <i
        data-testid={`btneditcs${info.row.original.ID}`}
        className="bi bi-pencil iconSearch"
        title="Ver Desviación"
        onClick={() => {
          setSelectedCausaSistema(info.row.original);
          setEstadoModalCausa(E_EstadoFormCausaDesviacion.Agregar);
          setIsOpenAddCS(true);
        }}></i>
    );
  };

  const componentEliminarCausaSistema = (info: any) => {
    return (
      <i
        data-testid={`btneliminarcs`}
        className="bi bi-trash iconSearch"
        title="Ver Desviación"
        onClick={() => {
          MySwal.fire({
            text: `¿Está seguro que desea eliminar el requisito del sistema?`,
            icon: "question",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showCloseButton: true,
            showCancelButton: true,
          }).then(async (result: SweetAlertResult) => {
            if (result.isConfirmed) {
              await DesviacionService.deleteCausaSistema(token, info.row.original.ID);
              await refreshTable();
            }
          });
        }}></i>
    );
  };

  const componentEliminarCausaInmediata = (info: any) => {
    return (
      <i
        className="bi bi-trash iconSearch"
        data-testid="btneliminarci"
        title="Ver Desviación"
        onClick={() => {
          MySwal.fire({
            text: `¿Está seguro que desea eliminar la causa inmediata?`,
            icon: "question",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showCloseButton: true,
            showCancelButton: true,
          }).then(async (result: SweetAlertResult) => {
            if (result.isConfirmed) {
              await DesviacionService.deleteCausaInmediata(token, info.row.original.ID as number);
              await refreshTable();
            }
          });
        }}></i>
    );
  };

  const componentEliminar = (info: any) => {
    return (
      <i
        data-testid={`btneliminarevidenica${info.row.original.ID}`}
        className="bi bi-trash iconSearch"
        title="Ver Desviación"
        onClick={() => {
          MySwal.fire({
            text: `¿Está seguro que desea eliminar el documento?`,
            icon: "question",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showCloseButton: true,
            showCancelButton: true,
          }).then(async (result: SweetAlertResult) => {
            if (result.isConfirmed) {
              await DesviacionService.deleteDocumentoAnalisisCausal(token, info.row.original.ID as number);
              await loadDocumentsEvidencia();
            }
          });
        }}></i>
    );
  };

  const componentEditar = (info: any) => {
    return (
      <i
        data-testid="btneditci"
        className="bi bi-pencil iconSearch"
        title="Ver Desviación"
        onClick={() => {
          setSelectedCausaInmediata(info.row.original);
          setEstadoModalCausa(E_EstadoFormCausaDesviacion.Agregar);
          setIsOpenAddCI(true);
        }}></i>
    );
  };

  const componentVer = (info: any) => {
    return (
      <i
        className="bi bi-search iconSearch"
        title="Ver Desviación"
        onClick={() => {
          DesviacionService.getContenidoDocumentoAnalisCausal(token, info.row.original.URL);
        }}></i>
    );
  };

  const componentVerCausaInmediata = (info: any) => {
    return (
      <i
        className="bi bi-search iconSearch"
        data-testid="btnverci"
        title="Ver Desviación"
        onClick={() => {
          setSelectedCausaInmediata(info.row.original);
          setEstadoModalCausa(E_EstadoFormCausaDesviacion.Lectura);
          setIsOpenAddCI(true);
        }}></i>
    );
  };

  const componentVerCausaBasica = (info: any) => {
    return (
      <i
        data-testid={"btnvercb"}
        className="bi bi-search iconSearch"
        title="Ver causa básica"
        onClick={() => {
          setSelectedCausaBasica(info.row.original);
          setEstadoModalCausa(E_EstadoFormCausaDesviacion.Lectura);
          setIsOpenAddCB(true);
        }}></i>
    );
  };

  const componentEditarCausaBasica = (info: any) => {
    return (
      <i
        data-testid={"btneditcb"}
        className="bi bi-pencil iconSearch"
        title="Editar causa básica"
        onClick={() => {
          setSelectedCausaBasica(info.row.original);
          setEstadoModalCausa(E_EstadoFormCausaDesviacion.Agregar);
          setIsOpenAddCB(true);
        }}></i>
    );
  };

  const componentEliminarCausaBasica = (info: any) => {
    return (
      <i
        data-testid={`btneliminarcb${info.row.original.ID}`}
        className="bi bi-trash iconSearch"
        title="Eliminar causa básica"
        onClick={() => {
          MySwal.fire({
            text: `¿Está seguro que desea eliminar la causa básica?`,
            icon: "question",
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showCloseButton: true,
            showCancelButton: true,
          }).then(async (result: SweetAlertResult) => {
            if (result.isConfirmed) {
              await DesviacionService.deleteCausaBasica(token, info.row.original.ID);
              await refreshTable();
            }
          });
        }}></i>
    );
  };

  usePromiseEffect(async () => {
    if (idDesviacion) {
      let resultDesviacion = is_test ? ({} as IDesviacion) : await DesviacionService.getDesvicacionByID(token, idDesviacion);
      setSelectedDesviacion(resultDesviacion);

      if (readonly === undefined) {
        setIsReadOnly(
          resultDesviacion === null ||
            !(
              resultDesviacion?.ID_ESTADO === EnumEstadoDesviacion.RegistroAnalisisCausal ||
              resultDesviacion?.ID_ESTADO === EnumEstadoDesviacion.RegistroCausasInmediatas ||
              resultDesviacion?.ID_ESTADO === EnumEstadoDesviacion.RegistroAmbitosGestion
            )
        );
      }

      setIsFlujoCorto(
        flujo_corto ??
          (!(
            resultDesviacion?.ID_TIPO_DESVIACION === ETipoDesviacion.NoConformidad ||
            (resultDesviacion?.ID_TIPO_DESVIACION === ETipoDesviacion.Observacion && resultDesviacion?.ID_POTENCIALIDAD === E_GravedadPotencial.Alta)
          ) ||
            resultDesviacion?.ID_ESTADO === EnumEstadoDesviacion.RegistroCausasInmediatas ||
            resultDesviacion?.ID_ESTADO === EnumEstadoDesviacion.RegistroAmbitosGestion)
      );
      setIsLoading(false);
      await refreshTable();
      await loadDocumentsEvidencia();
    }
  }, []);

  const refreshTable = async (pagination?: IPagination, type?: ETipoCausa) => {
    const defaultPagination: IPagination = pagination || {
      ORDENADOPOR: "ID",
      ORIENTACION: "ASC",
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
    };

    if (type === ETipoCausa.Inmediata || type === undefined) {
      const resultListInmediata = is_test
        ? { data: items1 ?? [], pages: 10 }
        : await DesviacionService.getListadoCausaInmediata(token, {
            ...defaultPagination,
            ID: idDesviacion,
          });
      setListCausasInmediatas(resultListInmediata.data);
      totalPagesListCausasI.current = resultListInmediata.pages;
    }
    if (type === ETipoCausa.Basica || type === undefined) {
      const resultListBasica = is_test
        ? { data: items2 ?? [], pages: 10 }
        : await DesviacionService.getListadoCausaBasica(token, {
            ...defaultPagination,
            ID: idDesviacion,
          });
      setListCausasBasicas(resultListBasica.data);
      totalPagesListCausasB.current = resultListBasica.pages;
    }
    if (type === ETipoCausa.Sistema || type === undefined) {
      const resultListSistema = is_test
        ? { data: items3 ?? [], pages: 10 }
        : await DesviacionService.getListadoCausaSistema(token, {
            ...defaultPagination,
            ID: idDesviacion,
          });
      setListCausasSistema(resultListSistema.data);
      totalPagesListCausasS.current = resultListSistema.pages;
    }
  };

  const loadDocumentsEvidencia = async (pagination?: IPagination) => {
    const defaultPagination: IPagination = pagination || {
      ORDENADOPOR: "ID",
      ORIENTACION: "ASC",
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
    };
    setIsLoadingDocuments(true);
    let result = is_test
      ? { data: itemsDoc ?? [], pages: 10 }
      : await DesviacionService.getListadoDocumentosAnalisisCausal(token, {
          ...defaultPagination,
          ID_DESVIACION: idDesviacion,
          ID_TIPO_DOCUMENTO: E_TipoDocumentoDesviacion.ArbolCausal,
        });
    totalPagesListDocumentos.current = result.pages;
    setListadoDocumentosAC(result.data);
    setIsLoadingDocuments(false);
  };
  const handleUploadDocument = async () => {
    let f = is_test ? {} : ((refInptDocumentoAC.current?.files as FileList)[0] as any);
    let value: Partial<IDocumentoDesviacion> = {
      ID_TIPO_DOCUMENTO: E_TipoDocumentoDesviacion.ArbolCausal,
      ID_DESVIACION: selectedDesviacion?.ID as number,
      DESCRIPCION: refTxtDescripcionDocumento.current?.value,
      FILE: f,
    };
    setIsUploadingDocs(true);
    await DesviacionService.postDocumentoAnalisisCausal(token, value);
    setLenTxtDescripcionDocumento(0);
    await loadDocumentsEvidencia();
    setIsUploadingDocs(false);
  };

  const validateArbolCausal = (continuar: boolean) => {
    let arrErrors: string[] = [];
    let msjError: string[] = [];
    if (!isFlujoCorto) {
      if (!Array.from(document.getElementsByName("rBtnImpactoRiesgoIdentificado")).filter((rn) => (rn as HTMLInputElement).checked).length) {
        arrErrors.push("ESTA_IMPACTO_RIESGO_IDENTIFICADO_MATRIZ");
        msjError.push(`Para poder avanzar con el formulario debe seleccionar si la desviación es de impacto/riesgo identificado en la matriz.\n`);
      }
      if (!Array.from(document.getElementsByName("rBtnAdecuadamenteEvaluado")).filter((rn) => (rn as HTMLInputElement).checked).length) {
        arrErrors.push("ESTA_ADECUADAMENTE_EVALUADO");
        msjError.push(`Para poder avanzar con el formulario debe seleccionar si la desviación está adecuadamente evaluada.\n`);
      }
      if (!Array.from(document.getElementsByName("rBtnAdecuadamenteIdentificado")).filter((rn) => (rn as HTMLInputElement).checked).length) {
        arrErrors.push("ESTA_ADECUADAMENTE_IDENTIFICADO_CONTROL_MATRIZ");
        msjError.push(
          `Para poder avanzar con el formulario debe seleccionar si la desviación está adecuadamente identificado el control dentro de la matriz.\n`
        );
      }
      if (listadoDocumentosAC.length === 0) {
        msjError.push(`Para poder avanzar con el formulario se debe ingresar el Árbol Causal.\n`);
        arrErrors.push("ARBOL_CAUSAL");
      }
    }

    if (!isFlujoCorto && listCausasBasicas.length === 0) {
      msjError.push(`Para poder avanzar con el formulario se debe ingresar por lo menos una causa básica.\n`);
      arrErrors.push("CAUSA_BASICA");
    }

    if (
      selectedDesviacion?.ID_TIPO_DESVIACION !== ETipoDesviacion.OportunidadMejora &&
      isFlujoCorto &&
      listCausasInmediatas.filter((ci) => ci.ID_ESTADO === E_EstadoCausa.AccionRealizada).length === 0
    ) {
      msjError.push(`Para poder avanzar con el formulario se deben realizar la acción de las causas inmediatas.\n`);
      arrErrors.push("CAUSA_BASICA");
    }
    if (selectedDesviacion?.ID_TIPO_DESVIACION === ETipoDesviacion.OportunidadMejora && listCausasSistema.length === 0) {
      msjError.push(`Para poder avanzar con el formulario se deben realizar la acción de los ámbitos de gestión.\n`);
      arrErrors.push("CAUSA_BASICA");
    }
    setArrErrorEmpty(arrErrors);
    if (arrErrors.length > 0 && continuar) {
      MySwal.fire({
        text: `Error Ingreso de datos`,
        html: (
          <div>
            {msjError.map((me) => (
              <p key={me}>{me}</p>
            ))}
          </div>
        ),
        icon: "warning",
        confirmButtonText: "Aceptar",
        showCloseButton: true,
        showCancelButton: false,
      });
    }
    return arrErrors.length === 0;
  };

  const handleGuardarArbolCausal = async (continuar: boolean) => {
    if (is_test === undefined) {
      if (!validateArbolCausal(continuar)) {
        return false;
      }
    }
    const rBtnAdecuadamenteEvaluado = (document.querySelector("[name=rBtnAdecuadamenteEvaluado]:checked") as HTMLInputElement)?.value;
    const rBtnAdecuadamenteIdentificado = (document.querySelector("[name=rBtnAdecuadamenteIdentificado]:checked") as HTMLInputElement)?.value;
    const rBtnImpactoRiesgoIdentificado = (document.querySelector("[name=rBtnImpactoRiesgoIdentificado]:checked") as HTMLInputElement)?.value;
    setIsSendingData(true);
    await DesviacionService.postGuardarArbolCausal(token, {
      ID_DESVIACION: idDesviacion,
      CAMBIO_ESTADO: continuar,
      ENVIAR_NOTIFICACION: continuar,
      ESTA_ADECUADAMENTE_EVALUADO: rBtnAdecuadamenteEvaluado != null ? rBtnAdecuadamenteEvaluado === "Sí" : null,
      ESTA_ADECUADAMENTE_IDENTIFICADO_CONTROL_MATRIZ: rBtnAdecuadamenteIdentificado ? rBtnAdecuadamenteIdentificado === "Sí" : null,
      ESTA_IMPACTO_RIESGO_IDENTIFICADO_MATRIZ: rBtnImpactoRiesgoIdentificado ? rBtnImpactoRiesgoIdentificado === "Sí" : null,
    });
    setIsSendingData(false);
    if (continuar && selectedDesviacion?.ID_TIPO_DESVIACION === ETipoDesviacion.Observacion) {
      window.location.href = "/agregardesviacion?id=" + selectedDesviacion.ID;
    } else if (continuar) {
      window.location.href = "/desviacion";
    }
  };

  const columnHelperEvidenciasCargadas = createColumnHelper<IEvidenciasArbolCausal>();

  let columnsDefEvidenciasCargadas = [
    columnHelperEvidenciasCargadas.accessor((row) => row.URL, {
      id: "NOMBRE_DOCUMENTO",
      cell: (info: CellContext<IEvidenciasArbolCausal, string>) => componentValue(getFileName(info.getValue())),
      header: () => component("Nombre Documento"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperEvidenciasCargadas.accessor((row) => row.CATEGORIA, {
      id: "CATEGORIA",
      cell: (info: CellContext<IEvidenciasArbolCausal, string>) => componentValue("Árbol Causal"),
      header: () => component("Categoría"),
      tipo: ITipo_Campo.text,
      hide: true,
    } as any),
    columnHelperEvidenciasCargadas.accessor((row) => row.DESCRIPCION, {
      id: "DESCRIPCION",
      cell: (info: CellContext<IEvidenciasArbolCausal, string>) => componentValue(info.getValue()),
      header: () => component("Descripción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperEvidenciasCargadas.accessor((row) => row.ID, {
      id: "VER",
      cell: (info: CellContext<IEvidenciasArbolCausal, string>) => componentVer(info),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperEvidenciasCargadas.accessor((row) => row.ID, {
      id: "ELIMINAR",
      cell: (info: CellContext<IDesviacion, string>) => componentEliminar(info),
      header: () => component("Eliminar"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
      hide: isReadOnly,
    } as any),
  ] as any;

  //Columns Causa Inmediata
  const columnHelperCI = createColumnHelper<ICausaInmediata>();
  let columnsDefCausaInmediata = [
    columnHelperCI.accessor((row) => row.ACCION, {
      id: "ACCION",
      cell: (info: CellContext<ICausaInmediata, string>) => componentValue(info.getValue()),
      header: () => component("Acción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperCI.accessor((row) => row.RESPONSABLE_DISPLAY, {
      id: "RESPONSABLE_DISPLAY",
      cell: (info: CellContext<ICausaInmediata, string>) => componentValue(info.getValue()),
      header: () => component("Responsable"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperCI.accessor((row) => row.FECHA_ASIGNACION, {
      id: "FECHA_ASIGNACION",
      cell: (info: CellContext<ICausaInmediata, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha de Asignación"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperCI.accessor((row) => row.FECHA_HASTA, {
      id: "PLAZO",
      cell: (info: CellContext<ICausaInmediata, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Plazo"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperCI.accessor((row) => row.TIPO_CAUSA_INMEDIATA, {
      id: "ID_TIPO_CAUSA_INMEDIATA",
      cell: (info: CellContext<ICausaInmediata, string>) => componentValue(info.getValue()),
      header: () => component("Tipo de Causas Inmediatas"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperCI.accessor((row) => row.ACTO_CONDICION_SUBESTANDAR, {
      id: "ACTO_CONDICION_SUBESTANDAR",
      cell: (info: CellContext<IDesviacion, string>) => componentValue(info.getValue()),
      header: () => component("Acto/Condición Subestándar"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperCI.accessor((row) => row.ID, {
      id: "VER",
      cell: (info: CellContext<ICausaInmediata, string>) => componentVerCausaInmediata(info),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperCI.accessor((row) => row.ID, {
      id: "EDITAR",
      cell: (info: CellContext<ICausaInmediata, string>) => componentEditar(info),
      header: () => component("Editar"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
      hide: isReadOnly,
    } as any),
    columnHelperCI.accessor((row) => row.ID, {
      id: "ELIMINAR",
      cell: (info: CellContext<IDesviacion, string>) => componentEliminarCausaInmediata(info),
      header: () => component("Eliminar"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
      hide: isReadOnly,
    } as any),
  ] as any;

  //Columns Causa Básica
  const columnHelperCB = createColumnHelper<ICausaBasica>();
  let columnsDefCausaBasica = [
    columnHelperCB.accessor((row) => row.ACCION, {
      id: "ACCION",
      cell: (info: CellContext<ICausaBasica, string>) => componentValue(info.getValue()),
      header: () => component("Acción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperCB.accessor((row) => row.RESPONSABLE_DISPLAY, {
      id: "RESPONSABLE_DISPLAY",
      cell: (info: CellContext<ICausaBasica, string>) => componentValue(info.getValue()),
      header: () => component("Responsable"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperCB.accessor((row) => row.FECHA_ASIGNACION, {
      id: "FECHA_ASIGNACION",
      cell: (info: CellContext<ICausaBasica, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha de Asignació"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperCB.accessor((row) => row.FECHA_HASTA, {
      id: "PLAZO",
      cell: (info: CellContext<ICausaBasica, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Plazo"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperCB.accessor((row) => row.TIPO_CAUSA_BASICA, {
      id: "TIPO_CAUSA",
      cell: (info: CellContext<ICausaBasica, string>) => componentValue(info.getValue()),
      header: () => component("Tipo de Causas Básica"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperCB.accessor((row) => row.FACTORES_PERSONALES, {
      id: "FACTORES_PERSONALES",
      cell: (info: CellContext<ICausaBasica, string>) => componentValue(info.getValue()),
      header: () => component("Factores Personales o del Trabajo"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperCB.accessor((row) => row.CAPACIDADES, {
      id: "DESCRIPCION_TECNICA",
      cell: (info: CellContext<ICausaBasica, string>) => componentValue(info.getValue()),
      header: () => component("Descripción de la Causa"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperCB.accessor((row) => row.ID, {
      id: "VER",
      cell: (info: CellContext<ICausaBasica, string>) => componentVerCausaBasica(info),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperCB.accessor((row) => row.ID, {
      id: "EDITAR",
      cell: (info: CellContext<ICausaBasica, string>) => componentEditarCausaBasica(info),
      header: () => component("Editar"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
      hide: isReadOnly,
    } as any),
    columnHelperCB.accessor((row) => row.ID, {
      id: "ELIMINAR",
      cell: (info: CellContext<ICausaBasica, string>) => componentEliminarCausaBasica(info),
      header: () => component("Eliminar"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
      hide: isReadOnly,
    } as any),
  ] as any;

  //Columns Causa Sistema
  const columnHelperCS = createColumnHelper<ICausaSistema>();
  let columnsDefCausaSistema = [
    columnHelperCS.accessor((row) => row.ACCION, {
      id: "ACCION",
      cell: (info: CellContext<ICausaSistema, string>) => componentValue(info.getValue()),
      header: () => component("Acción"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperCS.accessor((row) => row.RESPONSABLE_DISPLAY, {
      id: "RESPONSABLE_DISPLAY",
      cell: (info: CellContext<ICausaSistema, string>) => componentValue(info.getValue()),
      header: () => component("Responsable"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperCS.accessor((row) => row.FECHA_ASIGNACION, {
      id: "FECHA_ASIGNACION",
      cell: (info: CellContext<ICausaSistema, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha de Asignación"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperCS.accessor((row) => row.FECHA_HASTA, {
      id: "PLAZO",
      cell: (info: CellContext<ICausaSistema, Date>) => componentValue(shortDate(info.getValue())),
      header: () => component("Plazo"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperCS.accessor((row) => row.REQUISITOS, {
      id: "REQUISITOS",
      cell: (info: CellContext<ICausaSistema, string>) => componentValue(info.getValue()),
      header: () => component("Tipo Ámbito de Gestión"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperCS.accessor((row) => row.REQUISITO_SISTEMA, {
      id: "REQUISITO_SISTEMA",
      cell: (info: CellContext<ICausaSistema, string>) => componentValue(info.getValue()),
      header: () => component("Descripción del Ámbito de Gestión"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperCS.accessor((row) => row.ID, {
      id: "VER",
      cell: (info: CellContext<ICausaSistema, string>) => componentVerCausaSistema(info),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperCS.accessor((row) => row.ID, {
      id: "EDITAR",
      cell: (info: CellContext<ICausaSistema, string>) => componentEditarCausaSistema(info),
      header: () => component("Editar"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
      hide: isReadOnly,
    } as any),
    columnHelperCS.accessor((row) => row.ID, {
      id: "ELIMINAR",
      cell: (info: CellContext<ICausaSistema, string>) => componentEliminarCausaSistema(info),
      header: () => component("Eliminar"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
      hide: isReadOnly,
    } as any),
  ] as any;

  return isLoading ? (
    <Loading />
  ) : (
    <div className="row">
      <button
        data-testid="btntestupload"
        hidden={true}
        onClick={() => {
          handleUploadDocument();
        }}></button>
      <button
        data-testid="btntestvalidate"
        hidden={true}
        onClick={() => {
          validateArbolCausal(true);
        }}></button>
      <button
        data-testid="btntestguardararbol"
        hidden={true}
        onClick={() => {
          handleGuardarArbolCausal(true);
        }}></button>
      <div className="col-12">
        <div className="rounded bg-white p-2 shadow">
          <div className="container-fluid mb-4">
            <h1 className="titPrincipal colorTit">Desviación</h1>
            <div className="card bg-light border p-3 pt-2 mt-2">
              <div className="row ajusteInput">
                <div className="col-12">
                  <h6>
                    <span className="textSeccion">Responsable</span>
                  </h6>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <label>Usuario</label>
                  <p className="mb-2">{selectedDesviacion?.RESPONSABLE_INVESTIGACION_DISPLAY}</p>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6"></div>
              </div>
            </div>
            {!isFlujoCorto && (
              <span>
                <div className="card bg-light border p-3 pt-2 mt-2">
                  <div className="row ajusteInput">
                    <div className="col-12">
                      <h6>
                        <span className="textSeccion">Template Árbol Causal</span>
                      </h6>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6">
                      <a
                        href="#"
                        onClick={() => {
                          ArbolCausalService.GetDocumento("");
                        }}>
                        Descargar Modelo Árbol Causal
                      </a>
                    </div>
                    <div className="col-sm-12 col-md-6 col-lg-6"></div>
                  </div>
                </div>
                <div className="card bg-light border p-3 pt-2 mt-2">
                  <div className="row ">
                    <div className="col-12">
                      <h6>
                        <span className="textSeccion">Árbol Causal</span>
                      </h6>
                    </div>
                    <div className="col-12">
                      {listadoDocumentosAC.length === 0 && !isLoadingDocuments && !isReadOnly && (
                        <div className="row mb-2 ajusteInput">
                          <div className="row border m-1 p-1 rounded">
                            <div className="col-sm-12 col-md-12 col-lg-2 mb-2">
                              <label>Descripción</label>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-10 mb-2">
                              <textarea
                                className="form-control form-control-sm"
                                rows={3}
                                ref={refTxtDescripcionDocumento}
                                maxLength={250}
                                onChange={(e) => {
                                  setLenTxtDescripcionDocumento(e.target.value.length);
                                }}></textarea>
                              <span>{lenTxtDescripcionDocumento}/250</span>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-2 mb-2">
                              <label>Adjuntar </label>
                              <span className="text-danger">
                                <small> Peso máximo (50 mb).</small>
                              </span>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-10 mb-2">
                              <div className="input-group">
                                <input
                                  type="file"
                                  className="form-control form-control-sm"
                                  id="inputGroupFile04"
                                  aria-describedby="inputGroupFileAddon04"
                                  aria-label="Seleccionar Archivos"
                                  ref={refInptDocumentoAC}
                                />
                                {isUploadingDocs ? (
                                  <Loading />
                                ) : (
                                  <button
                                    className="btn btn-primary btn-sm"
                                    type="button"
                                    id="inputGroupFileAddon04"
                                    onClick={() => {
                                      handleUploadDocument();
                                    }}>
                                    Subir
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <AdminListaPagination
                        defaultSortBy="ID"
                        sortDirection="DESC"
                        totalPages={totalPagesListDocumentos}
                        callback={(pagination) => {}}
                        reload={() => {}}
                        columnsDef={columnsDefEvidenciasCargadas}
                        data={listadoDocumentosAC || []}
                        hideAdd={true}
                        hideExport={true}
                        hidePagination={true}
                        hideFilters={true}
                        isLoading={isLoadingDocuments}
                        hideReload={true}
                      />
                    </div>
                  </div>
                </div>
              </span>
            )}

            <div className="" id="collapseGeneradas">
              <div className="card card-body border-0 p-0 mt-2">
                <div className="row">
                  <div className="col-12">
                    <div className="rounded bg-white p-2 shadow">
                      <div className="container-fluid mb-4">
                        {!isFlujoCorto && (
                          <div className="col-sm-12 col-md-6 col-lg-6">
                            <div className="text-danger p-2" role="alert">
                              Fecha de Vencimiento de Análisis Causal<strong> {shortDate(selectedDesviacion?.FECHA_VENCIMIENTO)}</strong>
                            </div>
                          </div>
                        )}

                        <div className="row">
                          <Tabs
                            defaultActiveKey={
                              isFlujoCorto
                                ? selectedDesviacion?.ID_TIPO_DESVIACION !== ETipoDesviacion.OportunidadMejora
                                  ? "inmediatas"
                                  : "sistema"
                                : "básicas"
                            }
                            id="uncontrolled-tab-example"
                            className="mb-3">
                            {selectedDesviacion?.ID_TIPO_DESVIACION !== ETipoDesviacion.OportunidadMejora && (
                              <Tab
                                eventKey="inmediatas"
                                title={
                                  <span>
                                    {isFlujoCorto && (
                                      <span className="text-danger">
                                        <strong>(*)</strong>{" "}
                                      </span>
                                    )}
                                    Causas Inmediatas (Corrección) <i className="bi bi-eye" />
                                  </span>
                                }>
                                {!isReadOnly && (
                                  <button
                                    data-testid="btnagregarci"
                                    className="btn btn-primary btn-sm"
                                    onClick={() => {
                                      setEstadoModalCausa(E_EstadoFormCausaDesviacion.Agregar);
                                      setSelectedCausaInmediata(null);
                                      setIsOpenAddCI(true);
                                    }}>
                                    {" "}
                                    <i className="bi bi-plus-circle-fill"></i> Agregar
                                  </button>
                                )}
                                <AdminListaPagination
                                  defaultSortBy="ID"
                                  sortDirection="DESC"
                                  totalPages={totalPagesListCausasI}
                                  callback={(pagination) => {
                                    refreshTable(pagination, ETipoCausa.Inmediata);
                                  }}
                                  reload={() => {
                                    refreshTable(undefined, ETipoCausa.Inmediata);
                                  }}
                                  columnsDef={columnsDefCausaInmediata}
                                  data={listCausasInmediatas || []}
                                  hideAdd={true}
                                  hideExport={true}
                                />
                              </Tab>
                            )}
                            {!isFlujoCorto && (
                              <Tab
                                eventKey="básicas"
                                title={
                                  <span>
                                    {!isFlujoCorto && (
                                      <span className="text-danger">
                                        <strong>(*)</strong>{" "}
                                      </span>
                                    )}
                                    Causas Básicas <i className="bi bi-eye" />
                                  </span>
                                }>
                                {!isReadOnly && (
                                  <button
                                    data-testid="btnagregarcb"
                                    className="btn btn-primary btn-sm"
                                    onClick={() => {
                                      setEstadoModalCausa(E_EstadoFormCausaDesviacion.Agregar);
                                      setSelectedCausaBasica(null);
                                      setIsOpenAddCB(true);
                                    }}>
                                    {" "}
                                    <i className="bi bi-plus-circle-fill"></i> Agregar
                                  </button>
                                )}
                                <AdminListaPagination
                                  defaultSortBy="ID"
                                  sortDirection="DESC"
                                  totalPages={totalPagesListCausasB}
                                  callback={(pagination) => {
                                    refreshTable(pagination, ETipoCausa.Basica);
                                  }}
                                  reload={() => {
                                    refreshTable(undefined, ETipoCausa.Basica);
                                  }}
                                  columnsDef={columnsDefCausaBasica}
                                  data={listCausasBasicas || []}
                                  hideAdd={true}
                                  hideExport={true}
                                />
                              </Tab>
                            )}
                            {selectedDesviacion?.ID_TIPO_DESVIACION === ETipoDesviacion.OportunidadMejora && (
                              <Tab
                                eventKey="sistema"
                                title={
                                  <span>
                                    {isFlujoCorto && (
                                      <span className="text-danger">
                                        <strong>(*)</strong>{" "}
                                      </span>
                                    )}
                                    Ámbitos de Gestión <i className="bi bi-eye" />
                                  </span>
                                }>
                                {!isReadOnly && (
                                  <button
                                    className="btn btn-primary btn-sm"
                                    data-testid="btnagregarcs"
                                    onClick={() => {
                                      setEstadoModalCausa(E_EstadoFormCausaDesviacion.Agregar);
                                      setSelectedCausaSistema(null);
                                      setIsOpenAddCS(true);
                                    }}>
                                    {" "}
                                    <i className="bi bi-plus-circle-fill"></i> Agregar
                                  </button>
                                )}
                                <AdminListaPagination
                                  defaultSortBy="ID"
                                  sortDirection="DESC"
                                  totalPages={totalPagesListCausasS}
                                  callback={(pagination) => {
                                    refreshTable(pagination, ETipoCausa.Sistema);
                                  }}
                                  reload={() => {
                                    refreshTable(undefined, ETipoCausa.Sistema);
                                  }}
                                  columnsDef={columnsDefCausaSistema}
                                  data={listCausasSistema || []}
                                  hideAdd={true}
                                  hideExport={true}
                                />
                              </Tab>
                            )}
                          </Tabs>
                          {!isFlujoCorto && (
                            <span>
                              <div className="col-12 mt-3">
                                <label>
                                  <span className="text-danger">
                                    <strong>(*)</strong>
                                  </span>{" "}
                                  ¿Está el impacto/riesgo identificado en la matriz?
                                </label>
                              </div>
                              <div className={`col-12 mb-2 ${arrErrorEmpty.includes("ESTA_IMPACTO_RIESGO_IDENTIFICADO_MATRIZ") && "error"}`}>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="rBtnImpactoRiesgoIdentificado"
                                    value="Sí"
                                    defaultChecked={
                                      selectedDesviacion?.IMPACTO_RIESGO_IDENTIFICADO_MATRIZ != null
                                        ? selectedDesviacion.IMPACTO_RIESGO_IDENTIFICADO_MATRIZ
                                        : undefined
                                    }
                                    disabled={isReadOnly}
                                  />
                                  <label className="form-check-label">Sí</label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="rBtnImpactoRiesgoIdentificado"
                                    value="No"
                                    defaultChecked={
                                      selectedDesviacion?.IMPACTO_RIESGO_IDENTIFICADO_MATRIZ != null
                                        ? !selectedDesviacion.IMPACTO_RIESGO_IDENTIFICADO_MATRIZ
                                        : undefined
                                    }
                                    disabled={isReadOnly}
                                  />
                                  <label className="form-check-label">No</label>
                                </div>
                              </div>
                              <div className="col-12">
                                <label>
                                  <span className="text-danger">
                                    <strong>(*)</strong>
                                  </span>{" "}
                                  ¿Está adecuadamente evaluado?
                                </label>
                              </div>
                              <div className={`col-12 mb-2 ${arrErrorEmpty.includes("ESTA_ADECUADAMENTE_EVALUADO") && "error"}`}>
                                <div className="form-check form-check-inline">
                                  <input
                                    className={`form-check-input`}
                                    type="radio"
                                    name="rBtnAdecuadamenteEvaluado"
                                    value="Sí"
                                    defaultChecked={
                                      selectedDesviacion?.ADECUADAMENTE_EVALUADO != null ? selectedDesviacion.ADECUADAMENTE_EVALUADO : undefined
                                    }
                                    disabled={isReadOnly}
                                  />
                                  <label className="form-check-label">Sí</label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="rBtnAdecuadamenteEvaluado"
                                    value="No"
                                    defaultChecked={
                                      selectedDesviacion?.ADECUADAMENTE_EVALUADO != null ? !selectedDesviacion.ADECUADAMENTE_EVALUADO : undefined
                                    }
                                    disabled={isReadOnly}
                                  />
                                  <label className="form-check-label">No</label>
                                </div>
                              </div>
                              <div className="col-12">
                                <label>
                                  <span className="text-danger">
                                    <strong>(*)</strong>
                                  </span>{" "}
                                  ¿Está adecuadamente identificado el control dentro de la matriz?
                                </label>
                              </div>
                              <div className={`col-12 mb-2 ${arrErrorEmpty.includes("ESTA_ADECUADAMENTE_IDENTIFICADO_CONTROL_MATRIZ") && "error"}`}>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="rBtnAdecuadamenteIdentificado"
                                    value="Sí"
                                    defaultChecked={
                                      selectedDesviacion?.ADECUADAMENTE_IDENTIFICADO_CONTROL_MATRIZ != null
                                        ? selectedDesviacion.ADECUADAMENTE_IDENTIFICADO_CONTROL_MATRIZ
                                        : false
                                    }
                                    disabled={isReadOnly}
                                  />
                                  <label className="form-check-label">Sí</label>
                                </div>
                                <div className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name="rBtnAdecuadamenteIdentificado"
                                    value="No"
                                    defaultChecked={
                                      selectedDesviacion?.ADECUADAMENTE_IDENTIFICADO_CONTROL_MATRIZ != null
                                        ? !selectedDesviacion.ADECUADAMENTE_IDENTIFICADO_CONTROL_MATRIZ
                                        : false
                                    }
                                    disabled={isReadOnly}
                                  />
                                  <label className="form-check-label">No</label>
                                </div>
                              </div>
                            </span>
                          )}
                          {isSendingData ? (
                            <Loading />
                          ) : (
                            <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                              {!isReadOnly && (
                                <span>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-primary me-2"
                                    onClick={() => {
                                      handleGuardarArbolCausal(false);
                                    }}
                                    disabled={isSendingData}>
                                    <i className="bi bi-check2-circle me-2"></i> Guardar
                                  </button>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-primary  me-2"
                                    onClick={() => {
                                      handleGuardarArbolCausal(true);
                                    }}
                                    disabled={isSendingData}>
                                    <i className="bi bi-check-circle me-2"></i> Continuar
                                  </button>
                                </span>
                              )}
                              <button type="button" className="btn btn-sm btn-primary  me-2" onClick={() => (window.location.href = "/desviacion")}>
                                <i className="bi bi-arrow-left-circle me-2"></i> Volver
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isOpenAddCI && (
        <AgregarAnalisisCausalInmediato
          idDesviacion={idDesviacion}
          is_Test={is_test}
          token={token}
          isFlujoCorto={isFlujoCorto || false}
          onClose={() => {
            setEstadoModalCausa(E_EstadoFormCausaDesviacion.Lectura);
            setSelectedCausaInmediata(null);
            setIsOpenAddCI(false);
          }}
          onSave={() => {
            refreshTable();
            setIsOpenAddCI(false);
          }}
          selectedAnalisisCausal={selectdCausaInmediata}
          estadoForm={estadoModalCausa}
          isVistaDetallada={false}
          selectedAudit={selectedAudit}
        />
      )}
      {isOpenAddCB && (
        <AgregarAnalisisCausalBasica
          idDesviacion={idDesviacion}
          token={token}
          onClose={() => {
            setEstadoModalCausa(E_EstadoFormCausaDesviacion.Lectura);
            setSelectedCausaBasica(null);
            setIsOpenAddCB(false);
          }}
          onSave={() => {
            refreshTable();
            setIsOpenAddCB(false);
          }}
          selectedAnalisisCausalAC={selectdCausaBasica}
          estadoForm={estadoModalCausa}
          selectedAudit={selectedAudit}
        />
      )}
      {isOpenAddCS && (
        <AgregarAnalisisCausalSistema
          idDesviacion={idDesviacion}
          token={token}
          onClose={() => {
            setIsOpenAddCS(false);
            setEstadoModalCausa(E_EstadoFormCausaDesviacion.Lectura);
            setSelectedCausaSistema(null);
          }}
          onSave={() => {
            refreshTable();
            setIsOpenAddCS(false);
          }}
          selectedAnalisisCausalCS={selectdCausaSistema}
          estadoForm={estadoModalCausa}
          selectedAudit={selectedAudit}
        />
      )}
    </div>
  );
}
